import React from 'react'
import './index.css'
import App from './App'
import { createCustomTheme } from './theme'
import { ThemeProvider } from '@mui/material'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'
import { Toaster } from 'react-hot-toast'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'

const theme = createCustomTheme({ theme: 'LIGHT' })
const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <Router basename="/app">
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <Toaster
            toastOptions={{
              style: {
                maxWidth: '100vw',
                maxHeight: '100vh',
                padding: 0
              }
            }}
            containerStyle={{
              top: '50%',
              left: '50%',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)'
            }}
          />
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </ThemeProvider>
      </HelmetProvider>
    </Router>
  </React.StrictMode>
)

// A deploy replaces the hashed page chunks, so a tab opened before it fails to load the next lazy page.
// Reload once to pick up the new build; the time check stops a broken build from reloading forever.
window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem('chunk-reload-at') || 0)
  if (Date.now() - lastReload < 10_000) return
  sessionStorage.setItem('chunk-reload-at', String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

if (window.location.pathname === '/') {
  window.location.replace('/app')
}
